import BaseModel from './BaseModel';
import Researcher from './Researcher';

export default class UserInvite extends BaseModel {
  constructor(data = {}) {
    super(UserInvite, data);
    this.id = data.id;
    this.emailAddress = data.emailAddress;
    this.name = data.name;
    this.invitedBy = data.invitedBy
      ? new Researcher(data.invitedBy)
      : null;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
}
